import { mapCfEntityToCfAsset } from './mapper';

/**
 * This model represents Contentful Asset.
 * Read about it here:
 * https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/assets
 * @export
 * @class CfAsset
 */
export class CfAsset {
    static mapCfEntity = mapCfEntityToCfAsset;

    constructor(data) {
        this.url = data.url;
        this.contentType = data.contentType;
        this.image = data.image;
        this.title = data.title;
    }
}
